import React from 'react';
import {
	HealthPlanUser,
	useCreateHealthPlanUserMutation,
	useLazyHealthPlanIdQuery,
	useLazyHealthPlanUserQuery,
} from '../../../graphql/graphql';
import apiClient from '../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';

export const useHealthPlanUserHook = () => {
	const { setHealthPlanUser } = useHealthPlanContext();
	const [getHealthPlanUser] = useLazyHealthPlanUserQuery();
	const [getHealthPlanId] = useLazyHealthPlanIdQuery();
	const [createHealthPlanUser] = useCreateHealthPlanUserMutation();

	const submitData = async (
		patientId: string,
		healthPlanCode: string,
		data: Record<string, any>,
		onSuccess?: () => void,
	) => {
		const { healthPlanUser } = await getHealthPlanUser({
			userId: patientId,
			healthPlanCode: healthPlanCode,
		}).unwrap();

		if (!healthPlanUser) {
			const { healthPlan } = await getHealthPlanId({
				code: healthPlanCode,
			}).unwrap();
			if (healthPlan?.id) {
				createHealthPlanUser({
					healthPlanId: healthPlan.id,
					userId: patientId,
					questionnaireResultId: patientId,
				});
			}
		} else {
			await apiClient.patch(
				'/health-plan/' +
					healthPlanUser.healthPlanId +
					'/user/' +
					healthPlanUser.id,
				data,
			);
		}

		onSuccess?.();
	};

	const loadHealthPlanUser = async (
		patientId: string,
		healthPlanCode: string,
	) => {
		const { healthPlanUser: newHealthPlanUser } = await getHealthPlanUser({
			userId: patientId,
			healthPlanCode: healthPlanCode,
		}).unwrap();

		setHealthPlanUser(newHealthPlanUser as HealthPlanUser);
	};

	//CREATE NEW PLAN USER
	const initNewHealthPlanUser = async ({
		healthPlanId,
		patientId,
	}: {
		healthPlanId: string;
		patientId: string;
	}) => {
		return await createHealthPlanUser({
			healthPlanId: healthPlanId,
			userId: patientId,
		});
	};

	return {
		submitData,
		loadHealthPlanUser,
		initNewHealthPlanUser,
	};
};
